export default __webpack_public_path__ + "static/media/tianas1.52832d0f.jpg";